module.exports = __webpack_public_path__ + "static/media/walkin_logo_whitebg.e20db5bb.jpg";